/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';


@autoinject()
export class ManageRacesEthnicitiesPage {


}
